<template src="./Relatorio.html"></template>

<script>
import { mapMutations } from "vuex";
import Acordos from '@/pages/relatorios/Acordos';
import Dividas from '@/pages/relatorios/Dividas';

export default {
  components: {
    Dividas,
    Acordos
  },
  name: 'Relatorio',
  data () {
    return {
      model: {},
      active: 0,
    }
  },
  
  async created () {
    
    this.setLoading(true);
    this.setLoading(false);
  },
  methods: {
    ...mapMutations({
      setError: "setError",
      setLoading: "setLoading",
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="css" scoped>
</style>




// WEBPACK FOOTER //
// src/pages/relatorios/Relatorio.vue